import {getData, postData} from './redux_data';
import {
    GET_TIPOS_PARTIDA,
    MODIFY_TIPO_PARTIDA,
    ADD_TIPO_PARTIDA,
    DELETE_TIPO_PARTIDA,
    UPDATE_TIPOS_PARTIDA,
} from '../constants/action_types';

export function getTiposPartida() {
    return getData('vtipopartidas', GET_TIPOS_PARTIDA);
}

export function modifyTipoPartida(tipoPartida) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_TIPO_PARTIDA, payload: tipoPartida });
    }
}

export function addTipoPartida(tipoPartida) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_TIPO_PARTIDA, payload: tipoPartida });
    }
}

export function removeTipoPartida(tipoPartida) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_TIPO_PARTIDA, payload: tipoPartida });
    }
}

export function updateTiposPartidaDB (tipoPartida) {
    // return (dispatch, getState) => {
    //     dispatch({ type: UPDATE_TIPOS_PARTIDA, payload: tipoPartida })
    //     let token = getState().oidc.user ? getState().oidc.user.access_token : "";
    //     axios.post(config.API_URI() + 'vtipopartidas/partidas', tipoPartida,
    //         {
    //             headers: {
    //                 Authorization: "Bearer " + token
    //             }
    //         }
    //     ).then((response) => {
    //         dispatch({ type: UPDATE_TIPOS_PARTIDA + "_SUCCESS", payload: response })
    //         dispatch({
    //             type: OPEN_DIALOG,
    //             modalType: 'SimpleMessage',
    //             modalProps: { message: 'Cambios guardados!' },
    //             dialogid: 'success_update_tipos_partida'
    //             });
    //     }).catch((error) => {
    //         dispatch({
    //             type: OPEN_DIALOG,
    //             modalType: 'SimpleMessage',
    //             modalProps: { message: error.response.data.message, exception: error.response.data.ex },
    //             dialogid: 'error_update_tipos_partida'
    //         });
    //     });
    // }

    return postData('vtipopartidas/partidas', UPDATE_TIPOS_PARTIDA, tipoPartida, 'Tipos de partida actualizados', undefined);

}

